import i18n from '../i18n';

const TECHNICAL_CODES = ['functions/internal', 'functions/unavailable', 'functions/deadline-exceeded', 'functions/unknown'];

/**
 * Fehler einer Cloud Function für Anwender aufbereiten: Das Backend liefert Schlüssel (`backend.errors.*`),
 * die hier in der Sprache der Person übersetzt werden; technische Fehler ohne Schlüssel wie "internal"
 * (Netzwerk, Plattform, unerwartete Serverfehler) werden durch einen verständlichen Hinweis ersetzt.
 */
export function toUserError(err: unknown): Error {
    const code = (err as { code?: string } | null)?.code || '';
    const message = err instanceof Error ? err.message : String(err);
    if (message.startsWith('backend.errors.')) {
        return new Error(i18n.t(message, { defaultValue: i18n.t('common.serviceUnavailable') }));
    }
    if (TECHNICAL_CODES.includes(code) || /^internal\b/i.test(message)) {
        return new Error(i18n.t('common.serviceUnavailable', 'Der Dienst ist momentan nicht erreichbar. Bitte versuchen Sie es später erneut.'));
    }
    return err instanceof Error ? err : new Error(message);
}
